<template>
  <div class="showActBox">
    <img
      class="close-showActBox"
      src="@/assets/close.png"
      alt=""
      @click.stop="closePop"
    />
    <div class="content-box">
      <div
        class="showActBox-carousel"
        @mousedown="startDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
      >
        <div class="showActBox-carousel-slides" ref="slides" @mousemove="drag">
          <div
            v-for="(slide, index) in slides"
            :key="index"
            :class="{
              'showActBox-carousel-slide': true,
              active: currentIndex === index,
            }"
          >
            <img class="pc" :src="slide.imageUrl" alt="" />
          </div>
        </div>
        <div class="showActBox-carousel-pagination">
          <div
            v-for="(_, index) in slides"
            :key="index"
            :class="{
              'carousel-pagination-button': true,
              active: currentIndex === index,
            }"
            @click="goToSlide(index)"
          ></div>
        </div>
      </div>
    </div>

    <div class="carousel-pagination-img">
      <div v-for="(_, index) in slides" :key="index" @click="goToSlide(index)">
        <img
          class="img-button"
          :class="{
            imgButtonAct: currentIndex === index,
          }"
          :src="_.imageUrl"
          alt=""
        />
      </div>
    </div>
    <div class="showActBox-carousel-right">
      <div class="work-info" v-for="(item, index) in slides" :key="item.id">
        <div class="work-title" v-if="currentIndex === index">
          {{ lan ? item.titleEn : item.title }}
        </div>
        <div class="work-dec" v-if="currentIndex === index">
          {{ lan ? item.infoEn : item.info }}
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      slides: [],
      currentIndex: 0, // 当前显示的轮播图索引
      startX: 0,
      dragging: false,
      threshold: 50, // 滑动阈值，单位为像素
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    this.slides = this.showData;
    this.currentIndex = this.showIndex;
  },
  mounted() {
    setTimeout(() => {
      this.goToSlide(this.currentIndex);
    }, 100);
  },
  props: {
    showData: {
      type: Array,
      default: () => [], // 默认为空对象
    },
    showIndex: {
      type: Number,
      default: 0, // 默认为空对象
    },
    showType: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    startDrag(event) {
      this.startX = event.clientX;
      this.dragging = true;
    },
    drag(event) {
      if (!this.dragging) return;

      const deltaX = event.clientX - this.startX;
      const isLeftSwipe = deltaX > 0;
      const isRightSwipe = deltaX < 0;
      // 阻止默认滚动行为
      event.preventDefault();
    },
    endDrag(event) {
      if (!this.dragging) return;

      const deltaX = event.clientX - this.startX;
      if (Math.abs(deltaX) > this.threshold) {
        if (deltaX > 0) {
          // 右滑，切换到上一张
          this.prevSlide();
        } else {
          // 左滑，切换到下一张
          this.nextSlide();
        }
      }

      this.dragging = false;
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex + this.slides.length - 1) % this.slides.length;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    closePop() {
      this.$emit("closePop", this.showType);
    },
  },
};
</script>
<style scoped>
.showActBox {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 0;
}

.showActImg {
  width: 100%;
  height: 100%;
  opacity: 1;
}
.overlay-mask {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%; /* 蒙层高度 */
  background-color: rgba(0, 0, 0, 0.16); /* 半透明黑色 */
}
.showActBox-content-title {
  position: absolute;
  bottom: 30px;
  left: 30px;
  color: #fff;
}
.right-arrow {
  position: absolute;
  bottom: 30px;
  right: 30px;
  width: 32px;
  height: 20px;
}
.content-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.showActBox-carousel {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.showActBox-carousel-slides {
  display: flex;
  width: 100%; /* 假设有三个轮播项，每个轮播项宽100% */
  transition: transform 0.5s ease;
  color: #000;
}
.showActBox-carousel-slides .pc {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.showActBox-carousel-slide {
  flex: 0 0 100%;
  min-width: 100%;
  text-align: center;
  padding: 0px 0 20px;
}

.showActBox-carousel-slide.active {
  /* 实际上，由于我们使用了transform来定位活动轮播项，所以不需要这个类 */
}
.showActBox-carousel-right {
  position: relative;
  width: 100%;
  text-align: left;
}
.showActBox-carousel-pagination {
  position: absolute;
  left: 10px;
  bottom: 30px;
  display: flex;
}

.carousel-pagination-button {
  margin: auto 2px !important;
  opacity: 1;
  width: 13px;
  height: 2.6px;
  background: url(../../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  cursor: pointer;
}

.carousel-pagination-button.active {
  width: 13px;
  height: 2.6px;
  background: none;
  position: relative;
  background: url(../../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
}

.carousel-control {
  position: absolute;
  top: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  color: #000;
  border: none;
  cursor: pointer;
  z-index: 10;
}
.work-info {
  width: 100%;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 16;
  -webkit-box-orient: vertical;
  text-align: left;
}
.work-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 22px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin: 10px 20px;
}
.work-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  line-height: 18px;
  font-weight: 400;
  margin: 0 20px;
  min-height: 80px;
  max-height: 180px;

  overflow-y: auto;
}
.carousel-pagination-img {
  height: 50px;
  width: 94%;
  margin-left: 20px;
  overflow-x: scroll;
  display: flex;
}

.img-button {
  opacity: 0.5;
  margin: 0 8px 0 0 !important;
  max-width: 69px;
  max-height: 50px;
  cursor: pointer;
}
.imgButtonAct {
  opacity: 1;
  cursor: pointer;
}
.close-showActBox {
  position: absolute;
  right: 15px;
  top: -35px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>